export const hasToken = (t) =>
  t !== null &&
  t !== "null" &&
  t !== undefined &&
  t !== "undefined" &&
  t !== "";

  
  /**
   * Detecta la red de la tarjeta según el prefijo (BIN).
   * @param {string} cardNumber
   * @returns {{ name: string, lengths: number[], cvvLen: number }}
   */
  export const detectCardNetwork = (cardNumber) => {
    const num = cardNumber.replace(/\D/g, "");
  
    const networks = [
      { name: "amex", pattern: /^3[47]/, lengths: [15], cvvLen: 4 },
      {
        name: "mastercard",
        pattern: /^5[1-5]|^2(2[2-9]|[3-6]\d|7[01]|720)/,
        lengths: [16],
        cvvLen: 3,
      },
      { name: "visa", pattern: /^4/, lengths: [13, 16, 19], cvvLen: 3 },
      {
        name: "discover",
        pattern:
          /^6(011|22(1(2[6-9]|[3-9]\d)|[2-8]\d{2}|9([01]\d|2[0-5]))|4[4-9]\d|5\d{2})/,
        lengths: [16, 19],
        cvvLen: 3,
      },
      { name: "diners", pattern: /^3(0[0-5]|[68])/, lengths: [14], cvvLen: 3 },
      {
        name: "jcb",
        pattern: /^35(2[89]|[3-8]\d)/,
        lengths: [16, 17, 18, 19],
        cvvLen: 3,
      },
      {
        name: "unionpay",
        pattern: /^(62|81)/,
        lengths: [16, 17, 18, 19],
        cvvLen: 3,
      },
      {
        name: "maestro",
        pattern: /^(5018|5020|5038|6304|6759|676[1-3])/,
        lengths: [12, 13, 14, 15, 16, 17, 18, 19],
        cvvLen: 3,
      },
    ];
  
    for (const net of networks) {
      if (net.pattern.test(num)) return net;
    }
    return { name: "unknown", lengths: [16], cvvLen: 3 };
  };
  
  /**
   * Aplica formato de grupos al número de tarjeta.
   * Amex → 4-6-5  |  resto → 4-4-4-4
   * @param {string} value
   * @returns {string}
   */
  export const formatCardNumber = (value) => {
    const net = detectCardNetwork(value);
    const digits = value.replace(/\D/g, "");
  
    if (net.name === "amex") {
      return digits
        .slice(0, 15)
        .replace(/^(\d{1,4})(\d{1,6})?(\d{1,5})?/, (_, a, b, c) =>
          [a, b, c].filter(Boolean).join(" "),
        );
    }
    return digits.slice(0, 19).replace(/(\d{4})(?=\d)/g, "$1 ");
  };
  
  /**
   * Aplica máscara MM/AA mientras el usuario escribe.
   * @param {string} value
   * @returns {string}
   */
  export const formatExpiry = (value) => {
    const digits = value.replace(/\D/g, "").slice(0, 4);
    if (digits.length <= 2) return digits;
    return `${digits.slice(0, 2)}/${digits.slice(2)}`;
  };
  